export enum fixedColumnType {
  metric = "metric",
  total = "total",
}
